import React, {useEffect, Suspense} from 'react'
import {useSelector, useDispatch} from 'react-redux';
import ReactGA from 'react-ga4';
import loadLanguageOnPage from '../decorator/loadLanguageOnPage'
import HeaderComponent from './../components/HeaderComponent';
import BodyCenterComponent from './../components/BodyCenterComponent';
import BodyRightComponent from './../components/BodyRightComponent';
import FooterComponent from '../components/FooterComponent';
import logErrorTracker from '../decorator/logErrorTracker';
import BodyComponent from '../components/BodyComponent';
import templateServices from '../services/TemplateServices';
import BodyLeftComponent from '../components/BodyLeftComponent';
import CommonUtil from '../common/CommonUtil';
import mobileRedirector from '../decorator/mobileRedirector';
import isEqual from 'lodash/isEqual';
import maintenancePageChecker from '../decorator/maintenancePageChecker';
import CommonActions from '../actions/CommonActions';
import CasinoFilterBarMainCategoryComponent from '../components/CasinoComponent/CasinoFilterBarMainCategoryComponent';
import ComponentKeyMappings from "../common/ComponentKeyMappings";
import {changeMenuItem} from "../slices/UnifiedAccountSlice";
import {ACCOUNT_MENU_ITEM_ID} from "../components/AccountComponent/Constants";
import AccountAction from "../actions/AccountAction";
import IframeHOC from '../decorator/IframeHOC';

const MaintenanceSportPageComponent = CommonActions.lazyWithPreload(() => import( "../components/MaintenancePageComponent/MaintenanceSportPageComponent"));
const MaintenanceCasinoPageComponent = CommonActions.lazyWithPreload(() => import( "../components/MaintenancePageComponent/MaintenanceCasinoPageComponent"));

const DynamicPage = (props) => {

  const templateData = useSelector(state => state.LayoutTemplateSlice.templateData);
  const currentViewContainer = useSelector(state => state.LayoutTemplateSlice.currentViewContainer);
  const currentPageContainer = useSelector(state => state.LayoutTemplateSlice.currentPageContainer);
  const {pageContainer} = props;
  const router = CommonUtil.buildRouter(props);
  const dispatch = useDispatch();
  const isAuth = useSelector(state => state.AccountsSlice.user.auth);

  useEffect(() => {

    props.history.listen(location => {
      if (!window.env) {
        return;
      }
      const {isEnableGaGtm, gaWebId} = window.env;
      if (isEnableGaGtm && gaWebId) {
        ReactGA.set({page: location.pathname})
        ReactGA.send({ hitType: "pageview", page: location.pathname, title: pageContainer});
      }
    });
     const paramAfCode = CommonUtil.getParameterByName("a") || '';
     const paramAfTtId = CommonUtil.getParameterByName("ttid") || '';
     if (paramAfCode || paramAfTtId) {
       CommonUtil.setAfTtIdCookie(paramAfTtId);
       CommonUtil.setArfcCookie(paramAfCode);
       props.history.push(window.location.pathname);
     }
    return function cleanup() {
      // componentWillUnmount

    }
  }, []);
    const isEnabledATA = useSelector(state => state.AccountsSlice.user.ataSender);
  useEffect(() => {
    if (pageContainer === 'accountPageContainer') {
        if (isAuth === undefined) return;
        const {
            match: {params}
        } = props;
        if (isAuth) {
            let pageToGo = params.accountPage;
            if (ComponentKeyMappings[params.accountPage]) {
                if (params.accountPage === ACCOUNT_MENU_ITEM_ID.ATA_TRANSFERS && !isEnabledATA) {
                    pageToGo = ACCOUNT_MENU_ITEM_ID.PERSONAL_DETAILS;
                    props.history.push(`/${CommonUtil.getCurrentLang()}${AccountAction.getAccountViewPath()}/account/${pageToGo}`);
                }
            } else {
                pageToGo = ACCOUNT_MENU_ITEM_ID.PERSONAL_DETAILS;
                props.history.push(`/${CommonUtil.getCurrentLang()}${AccountAction.getAccountViewPath()}/account/${pageToGo}`);
            }
            dispatch(changeMenuItem(pageToGo));
        } else {
            props.history.push(AccountAction.gotoPage(''));
        }
    }
  }, [props.match.params.accountPage, isAuth]);

  function renderBody(isFixedHeader) {
    const isMaintenance = props.isMaintenance;

    if (pageContainer === 'sportPageContainer') {
      if (currentViewContainer === 'asiaView' || currentViewContainer === 'compactView') {
        return (
            isMaintenance ? <Suspense fallback={null}><MaintenanceSportPageComponent/> </Suspense> :
                <BodyComponent
                    fixedWhenScroll={isFixedHeader}
                    bodyLeftMenu={<BodyLeftComponent className='body-left' router={router}/>}
                    bodyRightMenu={<div></div>}
                    bodyCenter={<BodyCenterComponent className='body-center' router={router}/>}
                />
        );
      }

      return null
    } else if (pageContainer === 'betBuilderPageContainer') {
      if (currentViewContainer === 'asiaView' || currentViewContainer === 'compactView') {
        return (
          isMaintenance ? <Suspense fallback={null}><MaintenanceSportPageComponent/></Suspense> :
                <React.Fragment>
                  <BodyComponent
                      fixedWhenScroll={isFixedHeader}
                      bodyLeftMenu={<div></div>}
                      bodyRightMenu={<div></div>}
                      bodyCenter={<BodyCenterComponent className='body-center' router={router}/>}
                  />
                </React.Fragment>
        );
      }
    } else if (pageContainer === 'casinoPageContainer') {
      if (currentViewContainer === 'asiaView' || currentViewContainer === 'compactView') {
        const bodyLeft = (
            <div id="casino">
              <BodyLeftComponent className='body-left' router={router}/>
            </div>)
        return (
            isMaintenance ? <Suspense fallback={null}><MaintenanceCasinoPageComponent/></Suspense> :
                <React.Fragment>
                  <CasinoFilterBarMainCategoryComponent/>
                  <BodyComponent
                      fixedWhenScroll={isFixedHeader}
                      bodyLeftMenu={bodyLeft}
                      bodyCenter={<BodyCenterComponent className='body-center' router={router}/>}
                  />
                </React.Fragment>
        );
      }
    } else if (pageContainer === 'liveCasinoPageContainer') {
      if (currentViewContainer === 'asiaView' || currentViewContainer === 'compactView') {
        const bodyLeft = (
            <div id="casino">
              <BodyLeftComponent className='body-left' router={router}/>
            </div>)
        return (
            <React.Fragment>
              <CasinoFilterBarMainCategoryComponent/>
              <BodyComponent
                  fixedWhenScroll={isFixedHeader}
                  bodyLeftMenu={bodyLeft}
                  bodyCenter={<BodyCenterComponent className='body-center' router={router}/>}
              />
            </React.Fragment>
        );
      }
    } else if (pageContainer === 'accountPageContainer') {
      if (currentViewContainer === 'asiaView' || currentViewContainer === 'compactView') {
        return isAuth !== undefined && (
            <div id="unified-account-session-body">
              <BodyComponent
                  fixedWhenScroll={isFixedHeader}
                  bodyLeftMenu={<BodyLeftComponent className='body-left' router={router}/>}
                  bodyCenter={<BodyCenterComponent className='body-center' router={router}/>}
                  bodyRightMenu={<BodyRightComponent className="body-right" router={router}/>}
              />
            </div>
        );
      }
      return null
    } else if (pageContainer === 'promotionSurveyContainer') {
      return (
          <BodyComponent
            fixedWhenScroll={isFixedHeader}
            bodyCenter={<BodyCenterComponent className='survey-body-center' router={router}/>}
          />
      );
    } else if (pageContainer === "leaderboardContainer") {
      return (
        <BodyComponent
          fixedWhenScroll={isFixedHeader}
          bodyCenter={<BodyCenterComponent className='scoreboard-body-center' router={router}/>}
        />
      );
    }else {
      let bodyClassName = "";
      if (currentViewContainer === 'asiaView' || currentViewContainer === 'compactView') {
        bodyClassName = "";
      } else {
        bodyClassName = "classic-body-center";
      }
      return (
          <React.Fragment>
            <BodyComponent
                fixedWhenScroll={isFixedHeader}
                bodyCenter={<BodyCenterComponent className={bodyClassName}/>}
            />
          </React.Fragment>
      );
    }

  }

  let propsData = {
    templateData,
    currentViewContainer,
    currentPageContainer
  }

  let isFixedHeader = templateServices.isThisPageFixedHeader(propsData);
  let isClassViewSelected = currentViewContainer === 'classicView';
  return CommonUtil.isIniFrame() && pageContainer === 'accountPageContainer' || pageContainer === 'promotionSurveyContainer' ?
      renderBody(isFixedHeader):
  (
      <React.Fragment>
        <HeaderComponent
            fixedWhenScroll={isClassViewSelected ? false : isFixedHeader}
            router={router}
        />
        {renderBody(isFixedHeader)}
        <FooterComponent router={router}/>
      </React.Fragment>
  );
}

function preventRender(prevProps, nextProps) {
  return isEqual(prevProps.pageContainer, nextProps.pageContainer)
      && isEqual(prevProps.location.pathname, nextProps.location.pathname)
      && isEqual(prevProps.isMaintenance, nextProps.isMaintenance);
}

export default maintenancePageChecker()(logErrorTracker()(mobileRedirector()(loadLanguageOnPage()(React.memo(IframeHOC(DynamicPage), preventRender)))));


// WEBPACK FOOTER //
// ./src/app/pages/DynamicPage.js